import React from "react";

// Ticket #224 fase 1 — subcomponente memoizado de la CAJA 6 del HUD
// (HP / Mana / Oro / dmg / def / atributos).
//
// Antes vivía inline dentro del render() monolítico de pages/play/index.js
// (~8000 líneas). Cada setState({ user }) — que ocurre en ~29 sites de
// engine/connection/messages.js — disparaba reconciliation del árbol entero.
// En combate sostenido eso son 5-20 setStates/seg → stuttering.
//
// Como PureComponent compara props con shallow equality y todos los props
// que recibe son PRIMITIVOS (no objects/arrays), solo re-renderea cuando
// alguno de hp/mana/gold/dmg/def/attrs cambia de valor. Setstates que
// tocan otras partes del HUD (chat, modales, drag inv, etc) no lo tocan.
//
// IMPORTANTE: los stats de combate (dmgMin/Max, defMin/Max) se precalculan
// en el padre (pages/play/index.js → computeCombatStats) y se pasan como
// primitivos. Si los pasáramos como objects ({ min, max }), el PureComponent
// fallaría la shallow comparison porque cada render genera un nuevo
// reference.
export default class StatsBox extends React.PureComponent {
    render() {
        const {
            style,
            hp,
            maxHp,
            mana,
            maxMana,
            gold,
            attrFuerza,
            attrAgilidad,
            furiaActive,
            dmgMin,
            dmgMax,
            defMin,
            defMax
        } = this.props;

        // Tinte del número — el color solo aparece al llegar al cap 38:
        //
        //   1. Furia de Uhkrul (#50) explícita: ambos attrs en ROJO pulse.
        //      Detectado por flag furiaActive (server lo broadcastea por
        //      el packet furiaState al castear / cancelar). NO se usa
        //      heurística "ambos en 38" porque dos pociones independientes
        //      pueden coincidir en el cap sin haber casteado Furia.
        //
        //   2. Solo Fuerza en 38 (poción al máximo): marrón rojizo
        //      estático. Match con tono crimson del buff icon.
        //
        //   3. Solo Celeridad en 38: verde oliva estático. Match con
        //      tono lime del buff icon.
        //
        // Si un attr está debajo de 38 (buff parcial o sin buff), queda
        // en el color crema base — sin tinte.
        const fuerzaClass =
            style.fuerza +
            (furiaActive
                ? " " + style.attrFury
                : attrFuerza >= 38
                ? " " + style.attrBuffFuerza
                : "");

        const agilidadClass =
            style.agilidad +
            (furiaActive
                ? " " + style.attrFury
                : attrAgilidad >= 38
                ? " " + style.attrBuffCeleridad
                : "");

        const hpPct = maxHp
            ? Math.max(0, Math.min(100, (hp * 100) / maxHp))
            : 0;
        const manaPct = maxMana
            ? Math.max(0, Math.min(100, (mana * 100) / maxMana))
            : 0;

        const dmgTxt =
            dmgMin == null || dmgMax == null ? "—" : `${dmgMin}/${dmgMax}`;
        const defTxt =
            defMin == null || defMax == null ? "—" : `${defMin}/${defMax}`;

        return (
            <div className={style.statsBox}>
                <div className={style.hp}>
                    <div
                        className={style.progress_bar}
                        style={{ width: `${hpPct}%` }}
                    />
                    <div className={style.num}>{`${hp} / ${maxHp}`}</div>
                </div>
                <div className={style.mana}>
                    <div
                        className={style.progress_bar}
                        style={{ width: `${manaPct}%` }}
                    />
                    <div className={style.num}>{`${mana} / ${maxMana}`}</div>
                </div>
                <div className={style.gold}>{gold}</div>
                <div className={style.combatStats}>
                    <div
                        className={style.combatStat}
                        title="Daño total de armas equipadas (min/max)"
                    >
                        <span className={style.combatIcon}>🗡️</span>
                        <span>{dmgTxt}</span>
                    </div>
                    <div
                        className={style.combatStat}
                        title="Defensa total de armadura/escudo/casco equipados (min/max)"
                    >
                        <span className={style.combatIcon}>🛡️</span>
                        <span>{defTxt}</span>
                    </div>
                </div>
                <div className={style.attr}>
                    {/* 3 estados: Furia (rojo) / Solo Fuerza (marrón rojizo)
                        / Solo Celeridad (verde oliva). Ver computación
                        de classes al tope del render(). */}
                    <div className={fuerzaClass}>{attrFuerza}</div>
                    <div className={agilidadClass}>{attrAgilidad}</div>
                </div>
            </div>
        );
    }
}
